import { render, staticRenderFns } from "./HeaderButtonCompany.vue?vue&type=template&id=20a44c1d&scoped=true&"
import script from "./HeaderButtonCompany.vue?vue&type=script&lang=js&"
export * from "./HeaderButtonCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a44c1d",
  null
  
)

export default component.exports